import React from 'react'
import PropTypes from 'prop-types'
import STYLE_CONSTANTS from '~/style/constants'

const Presenter = ({ color, big }) => {
  return (
    <svg width={big ? "100px" : "50px"} height={big ? "100px" : "50px"} viewBox="0 0 50 50" version="1.1">
      <defs>
        <path
          d="M584,93.7154812 C584,91.2050209 586.2,90 587.5,90 C588.9,90 591,91.4058577 591,93.7154812 C591,95.7238494 590.2,97.5313808 589,98.4351464 L589,98.4351464 C588.7,98.7364017 588.4,98.8368201 588.1,98.9372385 L588,98.9372385 C587.8,98.9372385 587.7,99.0376569 587.5,99.0376569 C587.3,99.0376569 587.2,99.0376569 587,98.9372385 L586.9,98.9372385 C586.6,98.8368201 586.3,98.7364017 586,98.4351464 L586,98.4351464 C584.8,97.5313808 584,95.7238494 584,93.7154812 Z M598.5,107.07113 L576.5,107.07113 C575.7,107.07113 575,107.774059 575,108.577406 L575,109.58159 C575,110.384937 575.6,110.987448 576.4,111.087866 C577.3,111.48954 578.2,112.694561 578.2,113.598326 C578.2,113.799163 578.3,114 578.5,114 L578.5,114 L596.5,114 C596.8,114 597,113.799163 597,113.497908 C597,112.493724 598,111.288703 598.9,110.887029 L598.9,110.887029 C599.5,110.686192 600,110.083682 600,109.481172 L600,108.476987 C600,107.774059 599.3,107.07113 598.5,107.07113 Z M587,104.962343 C586.4,104.761506 586,104.158996 586,103.556485 C586,102.753138 586.7,102.050209 587.5,102.050209 C588.3,102.050209 589,102.753138 589,103.556485 C589,104.259414 588.6,104.761506 588,104.962343 L588,106.066946 L598,106.066946 L598,105.364017 C598,104.560669 597.5,103.857741 596.8,103.556485 L591.3,101.146444 C591.1,101.046025 590.9,100.945607 590.8,100.74477 C590.6,100.343096 590.2,99.6401674 590.1,98.8368201 C589.4,99.539749 588.5,100.041841 587.5,100.041841 C586.5,100.041841 585.6,99.539749 584.9,98.8368201 C584.7,99.6401674 584.4,100.343096 584.2,100.74477 C584.1,100.945607 583.9,101.046025 583.7,101.146444 L578.2,103.556485 C577.5,103.857741 577,104.560669 577,105.364017 L577,106.066946 L587,106.066946 L587,104.962343 L587,104.962343 Z"
          id="path-presenter"
        />
        <filter
          x="-92.0%"
          y="-79.2%"
          width="284.0%"
          height="291.7%"
          filterUnits="objectBoundingBox"
          id="filter-presenter"
        >
          <feOffset
            dx="0"
            dy="4"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          />
          <feGaussianBlur
            stdDeviation="7"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          />
          <feColorMatrix
            values="0 0 0 0 0.443137255   0 0 0 0 0.843137255   0 0 0 0 0.48627451  0 0 0 0.409250453 0"
            type="matrix"
            in="shadowBlurOuter1"
          />
        </filter>
      </defs>
      <g
        id="desktop-presenter"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="filled-presenter" transform="translate(-562.000000, -81.000000)">
          <g id="Shape-presenter">
            <use
              fill="black"
              fillOpacity="1"
              filter="url(#filter-presenter)"
              xlinkHref="#path-presenter"
            />
            <use fill={color} fillRule="evenodd" xlinkHref="#path-presenter" />
          </g>
        </g>
      </g>
    </svg>
  )
}

Presenter.defaultProps = {
  color: STYLE_CONSTANTS.colors.text.buttonGray
}

Presenter.propTypes = {
  color: PropTypes.string
}

export default Presenter
